const styles = () => ({
    footer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        color: "#ffffff",
        backgroundColor: "#474747",
        paddingTop: "7px",
        paddingBottom: "7px",
        width: "100%",
        marginTop: "10px",
    },

    rows: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingLeft: "10px",
        paddingRight: "10px",
    },

    text: {
        fontSize: "11px",
    },

    link: {
        color: "#ffffff",
    },
});

export default styles